<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <base-v-component
          heading="Настройка доступа"
        />
        <base-material-card
          title="Настройка доступа"
          color="primary"
          icon="mdi-security"
          inline
        >
          <v-card-text>
            <v-btn
              color="error"
              class="mb-5"
              @click="create_access"
            >
              <span class="mx-10">Перезагрузить права</span>
            </v-btn>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(item,i) in dict.entity"
                :key="i"
              >
                <v-expansion-panel-header>{{ item }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :items="access.filter(a=>a.entity == i)"
                    :headers="headers"
                    no-data-text="Нет данных для отображения"
                  >
                    <template v-slot:item="{item}">
                      <tr>
                        <td v-if="i == 34">
                          {{ dict.terminal_type[item.type] }}
                        </td>
                        <td v-if="i == 35">
                          {{ reminderEvent()[item.type].text }}
                        </td>
                        <td v-if="i != 34 && i != 35">
                          {{ dict.type[item.type] }}
                        </td>
                        <td
                          v-for="(role, k) in roles"
                          :key="'role_' + k"
                        >
                          <v-checkbox
                            v-model="item.roles"
                            :value="role.value"
                            @change="save_access(item)"
                          />
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div
              v-if="false"
              class="display-2 mt-4 mb-2"
            >
              Терминал
            </div>
            <v-expansion-panels v-if="false">
              <v-expansion-panel
                v-for="(item,i) in dict.terminal_entity"
                :key="i"
              >
                <v-expansion-panel-header>{{ item }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :items="terminal_access.filter(a=>a.entity == i)"
                    :headers="terminal_headers"
                    no-data-text="Нет данных для отображения"
                  >
                    <template v-slot:item="{item}">
                      <tr>
                        <td>{{ dict.terminal_type[item.type] }}</td>
                        <td
                          v-for="(role, k) in roles"
                          :key="'role_' + k"
                        >
                          <v-checkbox
                            v-model="item.roles"
                            :value="role.value"
                            @change="save_access(item)"
                          />
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { ReminderEvent } from "@/views/reminder/models/reminder.model"

  export default {
    data: () => ({
      roles: [],
      access: [],
      headers: [],
      terminal_access: [],
      terminal_headers: [],
      dict: {
          entity: {
              0: 'Пользователи',
              1: 'Справочники',
              2: 'Клиенты',
              3: 'События',
              4: 'Договора',
              5: 'Логи',
              6: 'Настройка доступа',
              7: 'Настройки системы',
              8: 'Таблицы',
              9: 'Записи',
              10: 'Документы',
              11: 'Папки',
              12: 'Места обслуживания',
              13: 'Каталог устройств',
              14: 'Список оборудования',
              15: 'Точки',
              16: 'Операторы',
              17: 'Получатели',
              18: 'Услуги и товары',
              19: 'Заказы',
              20: 'Платежи',
              21: 'Фискальные операции',
              22: 'Плательщики',
              23: 'Роли',
              24: 'Sbp',
              25: 'Категории',
              26: 'Подкатегории',
              27: 'Номенклатура',
              28: 'Конфигурация',
              29: 'Лояльность',
              30: 'Задачи',
              31: 'Профили СБП',
              32: 'Банки СБП',
              33: 'Интеграции',
              34: 'Терминал',
              35: 'Настройки уведомлений',
              36: 'Уведомления',
            37: 'Сверка итогов',
            38: 'Приход товара',
            39: 'Поставщики',
            40: 'Остатки',
            41: 'Перемещение',
            42: "Инвентаризация",
            43: 'Профайл',
          },
          type: {
              0: 'Открыть страницу',
              1: 'Просмотр всех записей',
              2: 'Просмотр своих записей',
              3: 'Изменение',
              4: 'Изменение своих записей',
              5: 'Создание',
              6: 'Ограниченное создание'
          },
          terminal_entity: {
            34: 'Терминал',
          },
          terminal_type: {
              0: "Выйти из приложения",
              1: "Сверка итогов",
              2: "Сброс сессии",
              3: "Переключить точку",
              4: "DataPhone - получение настроек",
              5: "DataPhone - тестовая оплата",
              6: "Создать задачу на отмену последней операции",
              7: "Принудительный переход на экран вендинга",
              8: "REMOTE VEND",
              9: "Управление реле",
              10: "Статус датчиков",
            11: "Добавить карту доступа",
            12: "Открыть дверь"
          },
      }
    }),
    mounted: function () {
      this.load()
      this.headers = [{
          text: 'Действие'
      }]
      this.terminal_headers = [{
          text: 'Действие'
      }]
      this.roles = []
      for (const x in this.$store.state.dict.role) {
          console.log('x=', x)
          console.log('this.$store.state.dict.role[x].name=', this.$store.state.dict.role[x].name)
          this.roles.push({ value: Number(x), text: this.$store.state.dict.role[x].name })
          this.headers.push({ value: Number(x), text: this.$store.state.dict.role[x].name })
          this.terminal_headers.push({ value: Number(x), text: this.$store.state.dict.role[x].name })
      }
    },
    methods: {
      save_access: function (access) {
          this.axios.post('/api/access/change', access)
          .then(response => {
            if (!response.data.error) {
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      load: function () {
        this.axios.post('/api/access/list')
          .then(response => {
            if (!response.data.error) {
              this.access = response.data.data
                console.log('this.access=', this.access)
            } else {
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      create_access: function () {
        this.axios.post('/api/access/create')
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Успешно')
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
      reminderEvent () {
        return ReminderEvent
      },
    },
  }
</script>

<style>

</style>
